import script from "./WorkingHours.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkingHours.vue?vue&type=script&setup=true&lang=js"

import "./WorkingHours.vue?vue&type=style&index=0&id=65bc6282&lang=css"
import "./WorkingHours.vue?vue&type=style&index=1&id=65bc6282&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65bc6282"]])

export default __exports__